export const EMAIL = /\S+@\S+\.\S+/;
